module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade modal-location-details",
    attrs: {
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._v("\n        Location Details\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('p', {
    staticClass: "material-details material-details-location-contact m-b-lg"
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" " + _vm._s(_vm.location.contact_name ? _vm.location.contact_name : '–')), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(" " + _vm._s(_vm.location.contact_phone ? _vm.location.contact_phone : '–') + " "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fa fa-phone"
  }), _vm._v(" " + _vm._s(_vm.location.contact_second_phone ? _vm.location.contact_second_phone : '–') + " "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "row row-clear-sm-6"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Property / Depot Name")]), _c('br'), _vm._v("\n              " + _vm._s(_vm.location.name) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("UHF Channel")]), _c('br'), _vm._v("\n              " + _vm._s(_vm.location.uhf_channel) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Address")]), _c('br'), _vm._v("\n              " + _vm._s(_vm.location.address) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Hours of Loading")]), _c('br'), _vm._v("\n              " + _vm._s(_vm.location.hours_of_loading) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row row-clear-sm-6 row-details"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Longitude")]), _c('br'), _vm._v("\n              " + _vm._s(_vm.location.longitude) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Latitude")]), _c('br'), _vm._v("\n              " + _vm._s(_vm.location.latitude) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "map-container"
  }, [(_vm.location.latitude && _vm.location.longitude) ? _c('gmap-map', {
    ref: "map",
    staticStyle: {
      "width": "100%",
      "height": "300px"
    },
    attrs: {
      "center": {
        lat: _vm.location.latitude,
        lng: _vm.location.longitude
      },
      "zoom": 8,
      "options": {
        streetViewControl: false,
        mapTypeControl: false,
        animatedZoom: false
      }
    }
  }, [_c('gmap-marker', {
    attrs: {
      "position": {
        lat: _vm.location.latitude,
        lng: _vm.location.longitude
      }
    }
  })], 1) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 footer-left"
  }, [_c('a', {
    staticClass: "btn btn-sm btn-primary",
    attrs: {
      "href": _vm.googleMapsLink,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-google"
  }), _vm._v(" Open In Maps")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 footer-right"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Close")]), _vm._v(" "), (_vm.jobIsEditable) ? _c('button', {
    staticClass: "btn btn-sm btn-info",
    attrs: {
      "data-toggle": "drawer",
      "data-target": "#drawer-location-add",
      "type": "button"
    },
    on: {
      "click": _vm.handleEditLocation
    }
  }, [_vm._v("\n              Edit Details\n            ")]) : _vm._e()])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-68531fb0"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/LocationDetailModal.vue
// module id = 1029
// module chunks = 0